"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import { Phone, Menu, X, ChevronDown } from "lucide-react"
import { useLocation } from "react-router-dom"
import { useAppointment } from "../context/AppointmentContext"
import { Calendar } from "lucide-react";

import Login from "./Login"

const Header = () => {
  const currentLocation = useLocation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isNewsOpen, setIsNewsOpen] = useState(false)
  const [isLoginOpen, setIsLoginOpen] = useState(false)

  const { open: openAppointment } = useAppointment()

  return (
    <>
      <header className="sticky top-0 z-50 w-full backdrop-blur-md bg-white/90 border-b border-apple-gray-100">

        {/* Main Navigation */}
        <div className="container mx-auto px-4">
          <div className="flex h-12 md:h-14 items-center justify-between">

            {/* Logo */}
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <img
                  src="/MAMS-Logo.png"
                  alt="MAMS Hospitals Logo"
                  className="h-12 w-50"
                />
              </Link>

              {currentLocation.pathname === "/" && (
                <h1 className="hidden">Mamatha Hospitals</h1>
              )}
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">

              <Link
                to="/"
                className="text-sm font-medium text-apple-gray-600 hover:text-apple-gray-500"
              >
                Home
              </Link>

              <Link
                to="/about"
                className="text-sm font-medium text-apple-gray-600 hover:text-apple-gray-500"
              >
                About Us
              </Link>

              <Link
                to="/departments"
                className="text-sm font-medium text-apple-gray-600 hover:text-apple-gray-500"
              >
                Departments
              </Link>

              <Link
                to="/doctors"
                className="text-sm font-medium text-apple-gray-600 hover:text-apple-gray-500"
              >
                Doctors
              </Link>

              <Link
                to="/health-packages"
                className="text-sm font-medium text-apple-gray-600 hover:text-apple-gray-500"
              >
                HealthPackages
              </Link>

              {/* News Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setIsNewsOpen(true)}
                onMouseLeave={() => setIsNewsOpen(false)}
              >
                <button
                  className="flex items-center gap-1 text-sm font-medium text-apple-gray-600 hover:text-apple-gray-500"
                  onClick={() => setIsNewsOpen(!isNewsOpen)}
                >
                  News
                  <ChevronDown
                    className={`h-4 w-4 transition-transform ${
                      isNewsOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {isNewsOpen && (
                  <div className="absolute left-0 top-full pt-2 w-44">
                    <div className="bg-white border border-apple-gray-100 rounded-lg shadow-lg overflow-hidden">

                      <Link
                        to="/news"
                        className="block px-4 py-3 text-sm text-apple-gray-600 hover:bg-apple-gray-50 hover:text-apple-gray-900"
                        onClick={() => setIsNewsOpen(false)}
                      >
                        News
                      </Link>

                      <Link
                        to="/blog"
                        className="block px-4 py-3 text-sm text-apple-gray-600 hover:bg-apple-gray-50 hover:text-apple-gray-900"
                        onClick={() => setIsNewsOpen(false)}
                      >
                        Blogs
                      </Link>

                    </div>
                  </div>
                )}
              </div>

              <Link
                to="/gallery"
                className="text-sm font-medium text-apple-gray-600 hover:text-apple-gray-500"
              >
                Gallery
              </Link>

              <Link
                to="/contact"
                className="text-sm font-medium text-apple-gray-600 hover:text-apple-gray-500"
              >
                Contact
              </Link>
            </nav>

            {/* Right Side */}
            <div className="flex items-center space-x-4">

              <a
                href="tel:7399999981"
                title="phone"
              >
                <Phone className="h-6 w-6 text-apple-gray-600 hidden md:block" />
              </a>

              <button
                  onClick={() => openAppointment()}
                  className="apple-button bookappointment hidden md:block whitespace-nowrap sm:text-xs"
                >
                  Book Appointment
                </button>

                <button
                  type="button"
                  onClick={() => setIsLoginOpen(true)}
                  className="hidden md:inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-apple-gray-700 border border-apple-gray-200 rounded-md hover:bg-apple-gray-50 transition-colors"
                >
                  Login
                </button>

              
              {/* Mobile Login + Menu */}
              <div className="md:hidden flex items-center gap-2">

                {/* Mobile Login */}
                <button
                  type="button"
                  onClick={() => {
                    setIsLoginOpen(true);
                    setIsMenuOpen(false);
                  }}
                  className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-800 transition hover:bg-gray-50"
                >
                  Login
                </button>

                {/* Mobile Menu Button */}
                <button
                  className="p-2 text-apple-gray-500"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  aria-label={
                    isMenuOpen
                      ? "Close navigation menu"
                      : "Open navigation menu"
                  }
                  title={isMenuOpen ? "Close Menu" : "Open Menu"}
                >
                  {isMenuOpen ? (
                    <X className="h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Menu className="h-6 w-6" aria-hidden="true" />
                  )}
                </button>

              </div>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-apple-gray-100">

            <nav className="flex flex-col p-4">

              <Link
                to="/"
                className="py-2 px-4 hover:bg-apple-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>

              <Link
                to="/about"
                className="py-2 px-4 hover:bg-apple-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>

              <Link
                to="/departments"
                className="py-2 px-4 hover:bg-apple-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Departments
              </Link>

              <Link
                to="/doctors"
                className="py-2 px-4 hover:bg-apple-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Doctors
              </Link>

              <Link
                to="/health-packages"
                className="py-2 px-4 hover:bg-apple-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Diagnostics & HealthPackages
              </Link>

              {/* Mobile News Dropdown */}
              <div>

                <button
                  className="w-full flex items-center justify-between py-2 px-4 hover:bg-apple-gray-50"
                  onClick={() => setIsNewsOpen(!isNewsOpen)}
                >
                  <span>News</span>

                  <ChevronDown
                    className={`h-4 w-4 transition-transform ${
                      isNewsOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {isNewsOpen && (
                  <div className="ml-4 border-l border-apple-gray-100">

                    <Link
                      to="/news"
                      className="block py-2 px-4 text-sm hover:bg-apple-gray-50"
                      onClick={() => {
                        setIsNewsOpen(false)
                        setIsMenuOpen(false)
                      }}
                    >
                      News
                    </Link>

                    <Link
                      to="/blog"
                      className="block py-2 px-4 text-sm hover:bg-apple-gray-50"
                      onClick={() => {
                        setIsNewsOpen(false)
                        setIsMenuOpen(false)
                      }}
                    >
                      Blogs
                    </Link>

                  </div>
                )}
              </div>

              <Link
                to="/gallery"
                className="py-2 px-4 hover:bg-apple-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Gallery
              </Link>

              <Link
                to="/contact"
                className="py-2 px-4 hover:bg-apple-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>

              {/* <div className="mt-4">
                <button
                  className="apple-button w-full"
                  onClick={() => {
                    setIsMenuOpen(false)
                    openAppointment()
                  }}
                >
                  Book Appointment
                </button>
              </div> */}

            </nav>
          </div>
        )}


      </header>
      {/* Mobile Fixed Book Appointment Button */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-[9999] bg-[#0f7777]">
        <button
          type="button"
          className="w-full h-[68px] flex items-center justify-center gap-2 text-white font-semibold text-lg"
          onClick={openAppointment}
        >
          <Calendar className="h-6 w-6" aria-hidden="true" />
          <span>Book Appointment</span>
        </button>
      </div>
      <Login
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
      />
    </>
  )
}

export default Header
